var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.7744H14C12.8954 10.7744 12 9.87898 12 8.77441V4.77441M12 15.2744V12.7744M12 15.2744V17.7744M12 15.2744H9.5M12 15.2744H14.5M18 10.6028V18.7744C18 19.879 17.1046 20.7744 16 20.7744H8C6.89543 20.7744 6 19.879 6 18.7744V6.77441C6 5.66984 6.89543 4.77441 8 4.77441H12.1716C12.702 4.77441 13.2107 4.98512 13.5858 5.3602L17.4142 9.18862C17.7893 9.5637 18 10.0724 18 10.6028Z",
    stroke: "#726881",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcons);
export default __webpack_public_path__ + "static/media/SaveIcons.f2810aa4b5c522f15c4a7a35314c711e.svg";
export { ForwardRef as ReactComponent };